import { fetchSameOrigin } from '../Utils';
import {React} from 'react';

function acceptCareRecipient(careRecipientId, caregiverRoleId, webAccessEnabled) {
  return fetchSameOrigin(
    `/members/${careRecipientId}/caregivers/${caregiverRoleId}/confirm`, 
    'PUT',
    { body: JSON.stringify({
    caregiver_id: caregiverRoleId,
    member_id: careRecipientId,
    web_access_enabled: webAccessEnabled})}
  )
  .then(r => r.json())
  .then(({ message, error })=> new Promise((resolve) => {
    resolve({
      message,
      error: !!error && !!error.length && (<ul><li>{error}</li></ul>)
    });
  })
  .finally(() =>{
    window.location.reload()
  }));
}

export default acceptCareRecipient;
